import { Component } from '@angular/core';
import { RouterLink } from "@angular/router";
import { FeatureHero } from '../../../../widgets/feature-hero/feature-hero';

@Component({
  selector: 'app-itsm-it-service',
  templateUrl: './page.html',
  styleUrl: './page.scss',
  standalone: true,
  imports: [RouterLink, FeatureHero],
})
export class ITServiceSolution {
  
  constructor() {}

}